import React from 'react'
import {
  Button,
  Confirm,
  usePermissions,
  useRecordContext,
  useUpdate,
  useNotify,
  useRefresh,
} from 'react-admin'

import { ROLES } from '../../components/constants'

const BLOCKED = 'blocked'

/**
 * Admin-only `PATCH /user-details/:id { action: 'block-user' }`: sets
 * `users.status = 'blocked'` (every existing session and every sign-in method
 * is rejected) and disables the user's Firebase account. No unblock.
 */
const BlockUserButton = () => {
  const record = useRecordContext()
  const { permissions } = usePermissions()
  const notify = useNotify()
  const refresh = useRefresh()
  const [open, setOpen] = React.useState(false)
  const [update, { isPending }] = useUpdate(
    'user-details',
    { id: record?.id, data: { action: 'block-user' } },
    {
      onSuccess: () => {
        notify('User blocked', { type: 'success' })
        refresh()
      },
      onError: error =>
        notify(`Error: ${error?.message || 'Could not block user'}`, {
          type: 'error',
        }),
    },
  )

  if (permissions !== ROLES.ADMIN) return null

  const isBlocked = record?.status === BLOCKED

  return (
    <>
      <Button
        label={isBlocked ? 'User blocked' : 'Block user'}
        variant="contained"
        color="error"
        onClick={() => setOpen(true)}
        disabled={isPending || isBlocked || !record?.id}
        sx={{ margin: '10px 5px 10px 10px' }}
      />
      <Confirm
        isOpen={open}
        title="Block user"
        content="Block this user? All their sessions end immediately, they can no longer sign in, and their Firebase account is disabled. This cannot be undone from the admin."
        onConfirm={() => {
          setOpen(false)
          update()
        }}
        onClose={() => setOpen(false)}
      />
    </>
  )
}

export default BlockUserButton
